import { useCurrencies } from '../hooks/useExchange';
import CurrencyIcon from './CurrencyIcon';
import './SupportedCoins.css';

const SupportedCoins = () => {
  const { data: currencies = [] } = useCurrencies();
  
  // Get popular currencies for the marquee
  const popularCurrencies = currencies.filter(c => 
    ['btc', 'eth', 'usdt', 'bnb', 'sol', 'ada', 'xrp', 'dot', 'doge', 'matic', 
     'ltc', 'link', 'uni', 'avax', 'atom', 'etc', 'xlm', 'trx'].includes(c.ticker.toLowerCase())
  );

  // Duplicate for seamless loop
  const marqueeCurrencies = [...popularCurrencies, ...popularCurrencies];

  return (
    <section className="supported-coins">
      <div className="coins-header">
        <h3 className="coins-title">
          <span className="gradient-text">1000+</span> Supported Currencies
        </h3>
        <p className="coins-subtitle">Exchange any cryptocurrency instantly</p>
      </div>

      <div className="coins-marquee">
        <div className="marquee-track">
          {marqueeCurrencies.map((currency, index) => (
            <div key={`${currency.id}-${index}`} className="marquee-item">
              <CurrencyIcon 
                currency={currency}
                size="md"
              />
              <span className="coin-code">{currency.ticker.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="coins-marquee reverse">
        <div className="marquee-track">
          {[...marqueeCurrencies].reverse().map((currency, index) => (
            <div key={`${currency.id}-rev-${index}`} className="marquee-item">
              <CurrencyIcon 
                currency={currency}
                size="md"
              />
              <span className="coin-code">{currency.ticker.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="coins-cta">
        <a href="/supported-coins" className="view-all-link">
          View all supported currencies
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 12l4-4-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default SupportedCoins;
